import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async AuthWithRMPOtp(otp) {
    return api.post(
      `/v1/auth/${otp}`,
      {},
      {
        baseURL: REACT_APP_API_A39,
      },
    );
  },
  async AuthWithRMPToken(token) {
    return api.post(
      `/v1/auth/token`,
      {},
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
